import(/* webpackMode: "eager" */ "/app/src/app/(Public)/page.tsx");
